/**
 * Mapowanie nazw ikon kategorii (Material Symbols → lucide-react component).
 * Używane w TransactionRow + Category picker (Faza 4).
 */
import { Icons } from '../components/Icons';
import type { ComponentType, SVGProps } from 'react';

type IconComp = ComponentType<SVGProps<SVGSVGElement> & { size?: number; strokeWidth?: number }>;

const map: Record<string, IconComp> = {
  // Wydatki — groceries vs general shopping (różne ikony żeby user je odróżnił)
  local_grocery_store: Icons.Food, // ShoppingBasket — koszyk na zakupy spożywcze
  grocery: Icons.Food,
  shopping_cart: Icons.Cart, // ShoppingCart — wózek (legacy "Zakupy")
  shopping_bag: Icons.Shopping, // ShoppingBag — torba
  shopping: Icons.Shopping,
  restaurant: Icons.Restaurant,
  car: Icons.Car,
  directions_car: Icons.Car,
  health: Icons.Health,
  medical_services: Icons.Health,
  home: Icons.Home,
  bills: Icons.Bills,
  receipt_long: Icons.Receipt,
  child: Icons.Child,
  child_care: Icons.Child,
  movie: Icons.Movie,
  sport: Icons.Sport,
  fitness_center: Icons.Sport,
  spa: Icons.Sparkles,
  sparkles: Icons.Sparkles,
  travel: Icons.Travel,
  flight: Icons.Travel,
  education: Icons.Education,
  school: Icons.Education,
  gift: Icons.Gift,
  card_giftcard: Icons.Gift,
  pets: Icons.Pets,
  trending_up: Icons.TrendingUp,
  more: Icons.MoreH,
  category: Icons.MoreH,
  // Przychody
  banknote: Icons.Banknote,
  payments: Icons.Banknote,
  family: Icons.Users,
  family_restroom: Icons.Users,
  bank: Icons.Bank,
  account_balance: Icons.Bank,
  coins: Icons.Coins,
  attach_money: Icons.Coins,
  // Cele
  piggy: Icons.PiggyBank,
  savings: Icons.PiggyBank,
  beach_access: Icons.Travel,
  laptop: Icons.Shopping,
};

export function getCategoryIcon(name: string | undefined): IconComp {
  if (!name) return Icons.MoreH;
  return map[name] ?? Icons.MoreH;
}
